const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const USERPROFILE_REQUEST = "USERPROFILE_REQUEST";
const USERPROFILE_ERROR = "USERPROFILE_ERROR";
const USERPROFILE_UPDATE = "USERPROFILE_UPDATE";
const USERPROFILE_UPDATE_ERROR = "USERPROFILE_UPDATE_ERROR";
const USERPROFILE_SUCCESS = "USERPROFILE_SUCCESS";
const USERPROFILE_PUT_SUCCESS = "USERPROFILE_PUT_SUCCESS";
const USERPROFILE_DELETE = "USERPROFILE_DELETE";
const USERPROFILE_DELETE_SUCCESS = "USERPROFILE_DELETE_SUCCESS";
const USERPROFILE_DELETE_ERROR = "USERPROFILE_DELETE_ERROR";
const USERPROFILE_CREATE = "USERPROFILE_CREATE";
const USERPROFILE_CREATE_SUCCESS = "USERPROFILE_CREATE_SUCCESS";
const USERPROFILE_CREATE_ERROR = "USERPROFILE_CREATE_ERROR";
const USERPROFILE_SWAP_CUSTOMER = "USERPROFILE_SWAP_CUSTOMER";
const USERPROFILE_SWAP_CUSTOMER_SUCCESS = "USERPROFILE_SWAP_CUSTOMER_SUCCESS";
const USERPROFILE_SWAP_CUSTOMER_ERROR = "USERPROFILE_SWAP_CUSTOMER_ERROR";
const USERS_ITEMS_NEEDING_ATTENTION = "USERS_ITEMS_NEEDING_ATTENTION";
const USERPROFILE_RESET_PASSWORD = "USERPROFILE_RESET_PASSWORD";
const USERPROFILE_RESET_PASSWORD_SUCCESS = "USERPROFILE_RESET_PASSWORD_SUCCESS";
const USERPROFILE_RESET_PASSWORD_ERROR = "USERPROFILE_RESET_PASSWORD_ERROR";
const USERPROFILE_CHANGE_PASSWORD = "USERPROFILE_CHANGE_PASSWORD";
const USERPROFILE_CHANGE_PASSWORD_SUCCESS = "USERPROFILE_CHANGE_PASSWORD_SUCCESS";
const USERPROFILE_CHANGE_PASSWORD_ERROR = "USERPROFILE_CHANGE_PASSWORD_ERROR";

import Vue from "vue";

const state = { status: "", user: null };

const getters = {
    getProfile: state => state.user ? state.user : {},
    isProfileLoaded: state => !!state.user,
    getProfileType: state => state.user? state.user.type : 5,
    validUser: (state) => (types) => { //Standardized call for usertype validation
        if(state.user !== null){ //Edge case to make sure user profile is loaded before parsing
            if(Array.isArray(types)){
                if(types.includes(state.user.type)){
                    return true
                } else {
                    return false
                }
            } else {
                return types === state.user.type
            }
        } else {
            return false
        }  
    }
};

const actions = {
    [USERPROFILE_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_REQUEST);
            commit('addLoading', {handle:'userprofile',name:'Load User Profile'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload.payload)
            };

            fetch(Vue.prototype.$apiServer + 'user/me', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'userprofile')
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_ERROR);
                    commit('removeLoading', 'userprofile')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [USERPROFILE_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_UPDATE);
            commit('addLoading', {handle:'userupdate' + payload.userid,name:'Update User Profile'})


            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'user/' + payload.userid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'userupdate' + payload.userid)
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_PUT_SUCCESS, payload);
                            dispatch(USERS_ITEMS_NEEDING_ATTENTION)
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_UPDATE_ERROR);
                    commit('removeLoading', 'userupdate' + payload.userid)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [USERPROFILE_DELETE]: ({ commit, dispatch }, userid) => {
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_DELETE);
            commit('addLoading', {handle:'userdelete' + userid,name:'Delete User Profile'})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload.payload)
            };

            fetch(Vue.prototype.$apiServer + 'user/' + userid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'userdelete' + userid)
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_DELETE_SUCCESS, userid);
                            dispatch(USERS_ITEMS_NEEDING_ATTENTION)
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_DELETE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_DELETE_ERROR);    
                    commit('removeLoading', 'userdelete' + userid)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [USERPROFILE_CREATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_CREATE);
            commit('addLoading', {handle:'usercreate',name:'Create User Profile'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'user', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'usercreate')
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_CREATE_SUCCESS);
                            dispatch(USERS_ITEMS_NEEDING_ATTENTION)
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_CREATE_ERROR);
                    commit('removeLoading', 'usercreate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [USERPROFILE_RESET_PASSWORD]: ({ commit }, payload) => {
    //    window.console.log("Resetting Password...")
    //    window.console.log("Reset Payload: " + JSON.stringify(uemail))
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_RESET_PASSWORD);
            commit('addLoading', {handle:'resetpassword',name:'Resetting User Password'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'user/passwordreset/request', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'resetpassword')
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_RESET_PASSWORD_SUCCESS);
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_RESET_PASSWORD_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_RESET_PASSWORD_ERROR);
                    commit('removeLoading', 'resetpassword')
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [USERPROFILE_CHANGE_PASSWORD]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_CHANGE_PASSWORD);
            commit('addLoading', {handle:'changepassword',name:'Changing User Password'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'user/passwordreset/submit', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'changepassword')
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_CHANGE_PASSWORD_SUCCESS);
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_CHANGE_PASSWORD_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_CHANGE_PASSWORD_ERROR);
                    commit('removeLoading', 'changepassword')
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [USERPROFILE_SWAP_CUSTOMER]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(USERPROFILE_SWAP_CUSTOMER);
            commit('addLoading', {handle:'customerchange' + payload.customerid, name:'Swap Customer Chameleon'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + "user/impersonate", loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'customerchange' + payload.customerid)
                        if (resp.result === 'Success') {
                            commit(USERPROFILE_SWAP_CUSTOMER_SUCCESS, payload);
                            resolve(resp)
                        } else {
                            commit(USERPROFILE_SWAP_CUSTOMER_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERPROFILE_SWAP_CUSTOMER_ERROR);
                    commit('removeLoading', 'customerchange' + payload.customerid)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
};

const mutations = {
    [USERPROFILE_REQUEST]: state => {
        state.status = "loading";
    },
    [USERPROFILE_UPDATE]: state => {
        state.status = "updating";
    },
    [USERPROFILE_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "user", resp.payload);
    },
    [USERPROFILE_PUT_SUCCESS]: (state) => {
        state.status = "success";
    },
    [USERPROFILE_ERROR]: state => {
        state.status = "error";
    },
    [USERPROFILE_UPDATE_ERROR]: state => {
        state.status = "error";
    },
    [USERPROFILE_DELETE]: () => {
        state.deleteprofilestatus = "loading";
    },
    [USERPROFILE_DELETE_SUCCESS]: () => {
        state.deleteprofilestatus = "success";
    },
    [USERPROFILE_DELETE_ERROR]: () => {
        state.deleteprofilestatus = "error";
    },
    [USERPROFILE_CREATE]: () => {
        state.createprofilestatus = "loading";
    },
    [USERPROFILE_CREATE_SUCCESS]: () => {
        state.createprofilestatus = "success";
    },
    [USERPROFILE_CREATE_ERROR]: () => {
        state.createprofilestatus = "error";
    },
    [USERPROFILE_SWAP_CUSTOMER]: () => {
        state.customerswapstatus = "loading";
    },
    [USERPROFILE_SWAP_CUSTOMER_SUCCESS]: () => {
        state.customerswapstatus = "success";
    },
    [USERPROFILE_SWAP_CUSTOMER_ERROR]: () => {
        state.customerswapstatus = "error";
    },
    [USERPROFILE_RESET_PASSWORD]: () => {
        state.passwordresetstatus = "error";
    },
    [USERPROFILE_RESET_PASSWORD_ERROR]: () => {
        state.passwordresetstatus = "error";
    },
    [USERPROFILE_RESET_PASSWORD_SUCCESS]: () => {
        state.passwordresetstatus = "success";
    },
    [USERPROFILE_CHANGE_PASSWORD]: () => {
        state.passwordchangestatus = "error";
    },
    [USERPROFILE_CHANGE_PASSWORD_ERROR]: () => {
        state.passwordchangestatus = "error";
    },
    [USERPROFILE_CHANGE_PASSWORD_SUCCESS]: () => {
        state.passwordchangestatus = "success";
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.user = {};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};